import React, { useEffect, useState } from "react";
import useMightyMouse from "react-hook-mighty-mouse";
import { motion } from "framer-motion";
// styling
import styled from "styled-components";
import { linkFlex, navFlex } from "./GlobalStyle";

// images
import arrowLink from "../images/arrowLink.svg";
import picture from "../images/picture.png";

function AboutMe() {
  return (
    <AboutMeStyle>
      <div className="selected">About Me</div>
      {/* whole about  --start */}
      <div className="about-me">
        {/* left - side --start */}
        <div className="left-side">
          {/* plenty content - start  */}
          <div className="info">
            Right from my desk in Nigeria, I collaborate remotely with
            designers, developers, and brand executives to implement ideas that
            define products. I have mastered harnessing{" "}
            {new Date().getFullYear() - 2019} years of design experience with my
            frontend development skills to build pixel-perfect interfaces while
            bearing in mind best practices.
            <br /> I have got special interest in blockchain and cryptocurrency.
            My time off code is for curating ideas for my blog, trying out my
            phone-photography skills, admiring other creatives' works, and
            teasing people who think Lionel Messi is not the Goat of Football.
          </div>

          {/* plenty content - end  */}
          {/* links  */}
          <div className="about-links links">
            <a
              className="link"
              href="mailto: folaborn2013@gmail.com?subject=Hello Samuel"
              target="_blank"
            >
              <div>Email</div>
              <img src={arrowLink} alt="my-email" />
            </a>
            <a
              className="link"
              href="https://www.linkedin.com/in/samuel-afolabi/"
              target="_blank"
            >
              <div>Linkedin</div>
              <img src={arrowLink} alt="linkedin" />
            </a>
            <a
              className="link"
              href="https://github.com/samuelafolabi"
              target="_blank"
            >
              <div>GitHub</div>
              <img src={arrowLink} alt="github" />
            </a>
            <a
              className="link"
              href="https://samuelafolabi.hashnode.dev"
              target="_blank"
            >
              <div>Blog</div>
              <img src={arrowLink} alt="github" />
            </a>
          </div>
          {/* links  */}
          <div>
            <img
              src={picture}
              alt="my-email"
              className="picture"
              loading="lazy"
            />
          </div>
        </div>
        {/* left - side --end */}
        {/* right - side --start */}
        <div className="right-side">
          <div className="right-title">perks</div>

          <div className="recog">
            <a
              className="link"
              href="https://twitter.com/AdobeXD/status/1397242321729622025?ref_src=twsrc%5Etfw"
              target="_blank"
            >
              <div>AdobeXD Feature</div>
              <img src={arrowLink} alt="my-email" />
            </a>
          </div>
          <div className="recog">
            <a
              className="link"
              href="https://www.upwork.com/freelancers/~0123787a41be460ace"
              target="_blank"
            >
              <div>Upwork's Top Rated</div>
              <img src={arrowLink} alt="my-email" />
            </a>
          </div>

          <div className="right-title">Skills | Tools</div>

          <div className="skill">Javascript</div>
          <div className="skill">React</div>
          <div className="skill">ContextAPI</div>
          <div className="skill">Redux ToolKit</div>
          <div className="skill">Styled-Components</div>
          <div className="skill">ChakraUI</div>
          <div className="skill">MaterialUI</div>
          <div className="skill">TailwindCSS</div>
          <div className="skill">Responsive Web Design</div>
          <div className="skill">Rainbow Kit</div>
          <div className="skill">Alchemy SDK</div>
          <div className="skill">Wagmi.sh</div>
          <div className="skill">AdobeXD</div>
          <div className="skill">Figma</div>
        </div>
        {/* right - side --end */}
      </div>
      {/* whole about  -end*/}
    </AboutMeStyle>
  );
}

export default AboutMe;

export const AboutMeStyle = styled.div`
  margin: 0 5px;
  .picture {
    width: 80%;
  }
  text-transform: lowercase;
  font-size: 1.8vw;
  .recog {
    display: flex;
    justify-content: center;
  }
  .about-links {
    text-transform: uppercase;
    display: flex;
    gap: 5vw;
  }
  .right-side {
    margin-top: -40px;
    text-transform: none;
    width: 45%;
  }

  .left-side {
    width: 45%;
  }

  .right-title {
    text-transform: uppercase;
    margin: 40px 0 20px 0;
    text-align: center;
  }

  .link {
    justify-content: center;
    margin-bottom: 20px;
    color: inherit;
  }

  .about-me {
    display: flex;
    justify-content: space-between;
  }

  .skill {
    text-align: center;
    margin-bottom: 20px;
  }
  .info {
    text-transform: none;
    margin-bottom: 4rem;
    line-height: 2.2vw;
  }
  @media only screen and (max-width: 600px) {
    .info {
      line-height: 22px;
    }
    .about-me {
      display: flex;
      flex-direction: column;
      font-size: 1.6rem;
    }
    .left-side {
      width: 100%;
    }
    .right-side {
      display: none;
    }
    .picture {
      width: 60vw;
    }
    .link > img {
      width: 1.6rem;
    }
    .info {
      text-transform: none;
      margin-bottom: 2rem;
    }
  }
`;
